<template>
    <div ref="container" class="container d-flex flex-column container mt-3">
        <loading ref="loading"></loading>
        <header class="text-center">
            <h1 class="h2">{{ $t('translations.oauth_authorisation') }}</h1>
            <!-- <p>{{ $t('translations.remember_to_click_save_below')}}</p> -->
        </header>
        <div ref="editScroller" class="card-default-mtb-0 flex-grow-1-scroll" v-html='oauth_form'>
        </div>
        <!-- <footer>
            <button v-on:click.prevent='validateItem($event)' class="btn btn-primary btn-block btn-round">
                {{ $t('translations.confirm')}}
            </button>
        </footer> -->
    </div>
</template>

<script>
export default {
    data: function(){
        return {
            oauth_form: ""
        }
    },
    mounted() {
        if(!this.$root.user) {
            this.$root.$router.push({path: "/login/oauth"});
            return;
        }
        this.getOAuthForm();
    },

    computed: {
        
    },
    
    methods: {
        getOAuthForm() {
            
            // axios.get('/oauth/tokens' + window.location.search).then((res) => {
            //     console.info("getOAuthForm", res);
            // }).catch((error) => {
            //     if(typeof error === 'object' && error !== null && typeof error.response === 'object' && error.response !== null) {
            //         console.log("Version check failed: " + error.response.data);
            //     }
            //     this.handleError(error, "application version");
            // });
            axios.get('/oauthform' + window.location.search).then((res) => {
                console.info("getOAuthForm", res);
                console.info("getOAuthForm", typeof res.data);
                if(typeof res.data === 'object' && res.data.redirect) {
                    window.location = "/oauth/authorize" + window.location.search;
                }
                else {
                    this.oauth_form = res.data;
                }
            }).catch((error) => {
                this.handleError(error, "error processing oauth request");
            });
        }
    }
}

</script>
